import * as Articles from 'layouts/weather/forecast/articles'
import * as Weather from '@avcan/prismic/clients/weather'
import { getLayout } from './'

export async function getStaticProps({ locale }) {
    return {
        props: {
            tutorial: await Weather.getTutorial('winds', locale),
        },
    }
}

export default function Winds({ tutorial }) {
    return <Articles.Winds tutorial={tutorial} />
}

Winds.getLayout = getLayout
